export default __webpack_public_path__ + "static/media/Wasswa 3.513ddd9d.jpg";